module.exports = __webpack_public_path__ + "img/tools-bg.052986ef.png";